import { sLog } from './serverLogging';
// TODO: Uncomment this when client logging is implemented
// import { cLog } from './clientLogging';
import { isServer } from '../../config/public/environment';

export const logger = (() => {
  if (isServer) {
    return sLog();
  }

  // TODO: Uncomment this when client logging is implemented
  // if (isClient && isProduction) {
  //   return cLog();
  // }

  return console;
})();
